export default __webpack_public_path__ + "static/jersey-02-92f388337a9a0ee491ef41893f4511ab.jpg";